<template>
  <sui-form-field :width="field.width || 16" :required="field.required" :error="isInvalid">
    <label>
      {{entity.amt > 1 ? 'Group name' : field.label}}
    </label>
    <sui-input v-model.trim="$attrs.value" :icon="icon" :disabled="field.readonly" :loading="loading" :placeholder="fieldPlaceholder" @input="onInput" />
    <small v-show="!error && entity.amt > 1">
      The host names will be <b>{{entity.name}}-1</b>, <b>{{entity.name}}-2</b>, etc.
    </small>
    <small class="errors">
      {{error}}
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormHostName',
    mixins: [
      FormField,
    ],
  }
</script>

<style scoped>
  .errors { display: none; color: #9f3a38; }
  .error > .errors { display: block; }
</style>
